export function setAuthToken(token) {
  sessionStorage.setItem("authToken", token);
}

export function getAuthToken() {
  return sessionStorage.getItem("authToken");
}

export function clearAuth() {
  sessionStorage.clear();
}
